var HeavyTorsoe = function (quality) {
  return {
    slot: 'torsoe',
    type: 'heavy',
    quality: quality,
    armorClass: Math.round(11 + quality * 85),
  };
};
module.exports = HeavyTorsoe;
